import './../../scss/theme/components/count-box.scss';
import fitty from 'fitty';
import { CountUp } from 'countup.js';


document.querySelectorAll(".count-box_value").forEach(function(item){
  const fitties = fitty(item, {
    minSize: window.innerWidth > 740 ? 10 : 10,
    maxSize: window.innerWidth > 740 ? 100 : 60,
  });
  setTimeout(function(){
    let suffix = (item.dataset.suffix === undefined) ? '' : item.dataset.suffix;
    let startvalue = (item.dataset.startvalue === undefined) ? 0 : item.dataset.startvalue;
    let counter = new CountUp(item, item.dataset.value, { enableScrollSpy: true, suffix: suffix, separator: item.dataset.separator, startVal: startvalue, decimalPlaces: item.dataset.decimalplaces, decimal: item.dataset.decimal });
    if (!counter.error) {
      counter.start();
    } else {
      console.error(counter.error);
    }
  }, 200);

});


